module.exports = "/assets/images/steam.png";